import { Avatar } from 'antd';
import { AvatarSize } from 'antd/es/avatar/AvatarContext';
import { FC, ReactNode } from 'react';

const UserAvatar: FC<{
  id: string;
  size?: AvatarSize;
  style?: React.CSSProperties;
  className?: string;
  children?: ReactNode;
}> = (props) => {
  const { id, size, style, className, children } = props;
  let source = `https://api.dicebear.com/9.x/shapes/svg?seed=${id}`;

  return (
    <Avatar
      className={className ? `avatar-box ${className}` : 'avatar-box'}
      style={{ ...style }}
      size={size || 'large'}
      src={source}
    >
      {children}
    </Avatar>
  );
};

export default UserAvatar;
